import React from 'react';
import {connect} from 'react-redux'
import { Button, message } from 'antd'
import DefaultDeviseTemplateContainer from '../DefaultDeviseTemplateContainer'
import ParentPassForm from './ParentPassForm'
import {
    editParentPass,
    updateParentPass
} from '../../actions'

import {history} from "../../router/history";

// import templateData from "../../reducers/template/templateReducers";

class ParentPassContaioner extends React.Component {

    componentWillMount() {
        this.props.editParentPass()
    }


    render() {
        return (
            <div>
                <DefaultDeviseTemplateContainer
                    title='家長接送證'
                    menuButton={this.menuButton()}
                    htmlBody={<ParentPassForm onSubmit={this.onSubmit} isLocked={this.props.isLocked}></ParentPassForm>}
                />
            </div>
        )

    }

    onSubmit = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法修改資料');
            return;
        }
        this.props.updateParentPass(value)
    }

    menuButton() {
        return (
            <Button onClick={() => this.goIndex()} >
                返回
            </Button>
        )
    }

    goIndex() {
        history.push('/devise_dashboard')
    }

}

const mapStateToProps = (state) => {
    const parentPassData = state.getIn(['ParentPass', 'data']);
    const safeParentPassData = parentPassData && parentPassData.toJS ? parentPassData.toJS() : (parentPassData || {});

    return {
        isLocked: !!safeParentPassData.ques_check,
    }
}

const mapDispatchToPorps = (dispatch) => ({
    editParentPass: () => (
        dispatch(editParentPass(dispatch))
    ),
    updateParentPass: (payload) => (
        dispatch(updateParentPass(dispatch, payload))
    )
})

export default connect(mapStateToProps, mapDispatchToPorps)(ParentPassContaioner)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentPassContaioner/ParentPassContaioner.jsx